/**
 * Created by developer on 23.10.17.
 */
import { get } from './request';
import { credentials } from '../constants';
export async function getConfiguration () {
  const {
    body: { env }
  } = await get(null, '/config/config.json');
  const { body: version } = await get(null, '/version.json');
  const { urls, keys } = credentials[env];
  return {
    urls,
    keys,
    version: {
      version: version.version,
      versionFull: `${version.version} build ${version.build} (${
        version.timestamp
      })`
    }
  };
}
